
import { supabase } from '../../client';
import { Customer } from '../types';
import { addShopInfoToCustomers } from './customerShops';

/**
 * Get customers for a specific shop
 */
export const getShopCustomers = async (organizationId: string, shopId: string): Promise<Customer[]> => {
  console.log(`[getShopCustomers] Fetching customers for shop ${shopId} in organization ${organizationId}`);
  
  try {
    // Get customers with stats then filter by shop_id
    const { data: customers, error } = await supabase
      .rpc('get_customers_with_stats', { org_id: organizationId })
      .eq('shop_id', shopId);
      
    if (error) {
      console.error('[getShopCustomers] Error retrieving customers:', error);
      return [];
    }
    
    console.log(`[getShopCustomers] Retrieved ${customers?.length || 0} customers for shop`);
    
    if (customers && customers.length > 0) {
      // Add shop information
      const customersWithShops = await addShopInfoToCustomers(customers);
      return customersWithShops;
    } else {
      console.log(`[getShopCustomers] No customers found for shop ${shopId}`);
      return [];
    }
  } catch (error) {
    console.error('[getShopCustomers] Error:', error);
    return [];
  }
};
